<div class="category-hero">
    <div class="skeleton skeleton-img-fluid"></div>
    <div class="category-hero-wrapper">
        <ng-container *ngIf="!categoryAd; else adTemplate">
            <picture class="banner-image" *ngIf="!!bannerDesktopUrl || !!bannerMobileUrl">
                <source media="(max-width: {{viewSizeMobile}}px)" [srcset]="bannerMobileUrl">
                <source [srcset]="bannerDesktopUrl">
                <img class="img-fluid mx-auto"
                     [src]="bannerDesktopUrl" [alt]="viewTitle"/>
            </picture>
        </ng-container>
    </div>
    <h1 class="category-hero-title heading-2" [ngClass]="{'skeleton skeleton-text': !viewTitle}">{{ viewTitle }}</h1>
    <p [innerHTML]="viewShortDesc" [ngClass]="{'skeleton skeleton-text': !viewShortDesc}"></p>
</div>

<ng-template #adTemplate>
    <a [href]="adLink" class="banner-item">
        <picture class="banner-image" *ngIf="!!bannerDesktopUrl || !!bannerMobileUrl">
            <source media="(max-width: {{viewSizeMobile}}px)" [srcset]="bannerMobileUrl">
            <source [srcset]="bannerDesktopUrl">
            <img class="img-fluid mx-auto" [src]="bannerDesktopUrl" [alt]="viewTitle"/>
        </picture>
    </a>
</ng-template>
